import {useMemo} from 'react';

import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {IMonitorPicker} from 'entities/monitor';

const SEARCH_LIMIT = 50;

const monitorLabel = (m: IHttpMonitorOutput) => m.name?.trim() || m.url_human_readable || m.url;

export const httpMonitorPicker: IMonitorPicker = {
    useSearch: (term) => {
        const {data} = httpMonitorAPI.useGetHttpMonitorsQuery({
            page: 1,
            limit: SEARCH_LIMIT,
            filters: [
                'status=active',
                ...(term ? [`url=${encodeURIComponent(term)}`] : []),
            ],
        });

        return useMemo(
            () => (data?.items ?? []).map((m) => ({uuid: m.uuid, label: monitorLabel(m)})),
            [data],
        );
    },
    useLabel: (uuid) => {
        const {data} = httpMonitorAPI.useGetHttpMonitorQuery(uuid);

        return data ? monitorLabel(data) : undefined;
    },
};
